// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"361":"621ec84e","2550":"4037ea3f","4268":"c08de77b","6950":"fbaa3b34","8097":"dc2e5980","8128":"95f94355","9657":"3038d77f","9967":"e060551b"}[chunkId] + ".chunk.css";
};